import { render } from "./App.vue?vue&type=template&id=9aee0336&scoped=true&ts=true&lang=pug"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=9aee0336&scoped=true&lang=css"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/PWA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aee0336"]])

export default __exports__